/* Moonou Sale-Countdown — generische Laufzeit- und Sichtbarkeits-Logik.
 *
 * Wofuer: die Countdown-Pill der Aktion (snippets/moonou-sale-countdown.liquid,
 * genutzt vom Kategorie-Hero) und jeder periodische Aktions-Countdown
 * (snippets/moonou-countdown.liquid mit Parameter period, z. B. im Ticket auf
 * der Produktseite). Bewusst getrennt von moonou-launch-promo.js — dieses
 * Skript kennt keine Aktionsmechanik, nur Zeit und Sichtbarkeit.
 *
 * Liquid-`now` ist wegen Page-Caching unzuverlaessig, deshalb rechnet dieses
 * Skript clientseitig — gleiches Muster wie moonou-launch-promo.js:
 * das Enddatum kommt als Unix-Timestamp (Sekunden) aus Liquid, erzeugt in der
 * Store-Zeitzone (Europe/Berlin), also unabhaengig von der Browser-Lokalzeit.
 *
 * Erwartete Attribute auf dem Wrapper [data-sale-countdown] (Pill) bzw.
 * [data-promo-countdown] (periodischer Countdown ohne Pill):
 *   data-sale-countdown-mode        "fixed" | "daily" | "weekly"
 *   data-sale-countdown-end-ts      Unix-Sekunden (fixed: Ende; daily/weekly:
 *                                   optionale Obergrenze = Ende der Aktion)
 *   data-sale-countdown-end         ISO-String (Rueckfall zu end-ts)
 *   data-sale-countdown-daily-hour  Stunde des periodischen Endes (daily/weekly)
 *   data-sale-countdown-daily-min   Minute des periodischen Endes (daily/weekly)
 *   data-sale-countdown-weekday     Wochentag des Endes, 0 = Sonntag (weekly)
 *
 * Modi:
 *   fixed  — laeuft bis zum Enddatum, danach wird die Pill ausgeblendet.
 *   daily  — laeuft jeden Tag bis zur eingestellten Uhrzeit (Europe/Berlin)
 *            und startet danach sofort neu.
 *   weekly — laeuft bis zum eingestellten Wochentag + Uhrzeit (Europe/Berlin)
 *            und startet danach sofort zur naechsten Woche neu.
 *   Bei daily/weekly mit gesetztem Ende der Aktion zaehlt der Countdown
 *   hoechstens bis zu diesem Ende; danach wird die Pill ausgeblendet.
 *
 * A/B-HOOK (Paket E, Mixpanel-Experiment) — wirkt NUR auf [data-sale-countdown]:
 *   window.moonouSaleCountdownVisible(false)  blendet den Countdown aus
 *   window.moonouSaleCountdownVisible(true)   hebt das Ausblenden wieder auf
 *   window.moonouSaleCountdownVisible(null)   setzt auf Theme-Logik zurueck
 * Der Override ueberlebt jeden internen Sweep. `true` kann einen abgelaufenen
 * Countdown NICHT wiederbeleben — abgelaufen bleibt abgelaufen.
 * Wer schon vor dem Laden dieses Skripts entscheiden will (flackerfrei),
 * setzt vorher window.moonouSaleCountdownDefaultVisible = false.
 * Gleiche API objektbasiert: window.MoonouSaleCountdown.setVisible(bool).
 *
 * Die reine Zeitrechnung (secondsUntilDaily/secondsUntilWeekly) laeuft ueber
 * module.exports auch in Node und ist in tests/aktionen-zwei-spuren.test.cjs
 * abgesichert.
 */
(function () {
  var DAY = 86400;

  /* Sekunden bis zum naechsten taeglichen Ende. clock = Wanduhr {h, m, s}. */
  function secondsUntilDaily(clock, hour, minute) {
    var diff = hour * 3600 + minute * 60 - (clock.h * 3600 + clock.m * 60 + clock.s);
    if (diff <= 0) diff += DAY;
    return diff;
  }

  /* Sekunden bis zum naechsten woechentlichen Ende. clock = Wanduhr
     {wd, h, m, s} mit wd 0 = Sonntag (wie Date#getDay und Liquid %w).
     Genau auf dem Endzeitpunkt beginnt schon die naechste Woche. */
  function secondsUntilWeekly(clock, weekday, hour, minute) {
    var target = weekday * DAY + hour * 3600 + minute * 60;
    var current = clock.wd * DAY + clock.h * 3600 + clock.m * 60 + clock.s;
    var diff = target - current;
    if (diff <= 0) diff += 7 * DAY;
    return diff;
  }

  function clampInt(value, min, max, fallback) {
    var n = parseInt(value, 10);
    return isNaN(n) || n < min || n > max ? fallback : n;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { secondsUntilDaily: secondsUntilDaily, secondsUntilWeekly: secondsUntilWeekly, clampInt: clampInt };
    return;
  }

  if (window.MoonouSaleCountdown) return;

  var SELECTOR = '[data-sale-countdown]';
  /* Periodische Countdowns ausserhalb der Pill (Ticket, Launch-Pill). Sie
     werden nur neu gestellt, nie vom A/B-Hook ausgeblendet. */
  var PERIODIC_SELECTOR = '[data-promo-countdown]';
  var WEEKDAYS = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  var HIDDEN_CLASS = 'moonou-sale-countdown--hidden';
  var TIMEZONE = 'Europe/Berlin';

  /* null = Theme entscheidet, true/false = vom A/B-Test erzwungen */
  var override =
    typeof window.moonouSaleCountdownDefaultVisible === 'boolean'
      ? window.moonouSaleCountdownDefaultVisible
      : null;

  var berlinFormatter = null;
  try {
    berlinFormatter = new Intl.DateTimeFormat('de-DE', {
      timeZone: TIMEZONE,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
  } catch (e) {
    /* Aeltere Browser ohne IANA-Zeitzonen: Rueckfall auf Browser-Lokalzeit.
       Fuer den daily-Modus ist das die einzige Abweichung, kein Fehlerfall. */
    berlinFormatter = null;
  }

  /* Wochentag in Europe/Berlin. Eigener Formatter mit en-US, weil nur dessen
     Kurznamen (Sun, Mon, ...) sprachunabhaengig stabil sind. */
  var weekdayFormatter = null;
  try {
    weekdayFormatter = new Intl.DateTimeFormat('en-US', { timeZone: TIMEZONE, weekday: 'short' });
  } catch (e) {
    weekdayFormatter = null;
  }

  /* Aktuelle Wanduhrzeit in Europe/Berlin als {wd, h, m, s} */
  function berlinClock() {
    var now = new Date();
    if (!berlinFormatter) {
      return { wd: now.getDay(), h: now.getHours(), m: now.getMinutes(), s: now.getSeconds() };
    }
    var parts = berlinFormatter.formatToParts(now);
    var out = { wd: now.getDay(), h: 0, m: 0, s: 0 };
    for (var i = 0; i < parts.length; i++) {
      var value = parseInt(parts[i].value, 10);
      if (isNaN(value)) continue;
      if (parts[i].type === 'hour') out.h = value === 24 ? 0 : value;
      if (parts[i].type === 'minute') out.m = value;
      if (parts[i].type === 'second') out.s = value;
    }
    if (weekdayFormatter) {
      var name = weekdayFormatter.format(now);
      if (name in WEEKDAYS) out.wd = WEEKDAYS[name];
    }
    return out;
  }

  function modeOf(el) {
    return el.getAttribute('data-sale-countdown-mode') || 'fixed';
  }

  /* daily und weekly laufen periodisch und starten nach jedem Ende neu. */
  function isPeriodic(el) {
    var mode = modeOf(el);
    return mode === 'daily' || mode === 'weekly';
  }

  /* Endzeitpunkt im fixed-Modus als ms-Timestamp (NaN = kein Ende gesetzt) */
  function endTime(el) {
    var time = NaN;
    var ts = el.getAttribute('data-sale-countdown-end-ts');
    if (ts) time = parseInt(ts, 10) * 1000;
    if (isNaN(time)) {
      var iso = el.getAttribute('data-sale-countdown-end');
      if (iso) time = new Date(iso).getTime();
    }
    return time;
  }

  /* Sekunden bis zum naechsten periodischen Ende (Europe/Berlin).
     Wird nach jedem Durchlauf neu aus der Berliner Wanduhr berechnet, damit
     sich die Zeitumstellung spaetestens beim naechsten Durchlauf selbst
     korrigiert. */
  function secondsUntilPeriodEnd(el) {
    var hour = clampInt(el.getAttribute('data-sale-countdown-daily-hour'), 0, 23, 23);
    var minute = clampInt(el.getAttribute('data-sale-countdown-daily-min'), 0, 59, 59);
    var clock = berlinClock();
    if (modeOf(el) === 'weekly') {
      var weekday = clampInt(el.getAttribute('data-sale-countdown-weekday'), 0, 6, 0);
      return secondsUntilWeekly(clock, weekday, hour, minute);
    }
    return secondsUntilDaily(clock, hour, minute);
  }

  /* Periodisch: aktiv, solange das (optionale) Ende der Aktion nicht erreicht
     ist. Fest: aktiv bis zum Enddatum, ohne Enddatum immer. */
  function isActive(el) {
    var time = endTime(el);
    return isNaN(time) || time > Date.now();
  }

  function setHidden(el, hidden) {
    if (hidden) {
      el.classList.add(HIDDEN_CLASS);
      el.setAttribute('aria-hidden', 'true');
    } else {
      el.classList.remove(HIDDEN_CLASS);
      el.removeAttribute('aria-hidden');
    }
  }

  var periodTimeouts = [];

  function clearPeriodTimeouts() {
    for (var i = 0; i < periodTimeouts.length; i++) clearTimeout(periodTimeouts[i]);
    periodTimeouts = [];
  }

  /* Setzt data-expires auf dem theme-Web-Component <countdown-timer> neu.
     Das Component cached das Datum in this._date und stoppt sich per
     complete() nach Ablauf (hidden = true) — beides muss zurueckgesetzt
     werden, sonst bleibt der Timer nach dem Rollover leer. */
  function armPeriod(el) {
    var timer = el.querySelector('countdown-timer');
    if (!timer) return;

    var seconds = secondsUntilPeriodEnd(el);
    /* Ende der Aktion vor dem Periodenende: bis dorthin zaehlen, danach
       nicht mehr neu starten (die Aktion ist vorbei). */
    var end = endTime(el);
    var capped = !isNaN(end) && end < Date.now() + seconds * 1000;
    var expiry = capped ? new Date(end) : new Date(Date.now() + seconds * 1000);
    timer.setAttribute('data-expires', expiry.toISOString());
    timer._date = null;
    timer.hidden = false;

    if (timer.timerInterval) {
      clearInterval(timer.timerInterval);
      timer.timerInterval = null;
    }
    /* init() existiert erst, wenn theme.js das Custom Element registriert hat.
       Fehlt es noch, uebernimmt der eigene inView-Start des Components und
       liest dann das frisch gesetzte data-expires. */
    if (typeof timer.init === 'function') timer.init();

    if (capped) return;
    /* Punktgenauer Neustart statt Warten auf den 30s-Sweep. */
    periodTimeouts.push(
      setTimeout(function () {
        armPeriod(el);
      }, seconds * 1000 + 1000)
    );
  }

  function sweep() {
    var elements = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      var visible = isActive(el) && override !== false;
      setHidden(el, !visible);
    }
  }

  function init() {
    clearPeriodTimeouts();
    var elements = document.querySelectorAll(SELECTOR + ', ' + PERIODIC_SELECTOR);
    for (var i = 0; i < elements.length; i++) {
      if (isPeriodic(elements[i]) && isActive(elements[i])) armPeriod(elements[i]);
    }
    sweep();
  }

  window.MoonouSaleCountdown = {
    /* A/B-Hook: true = anzeigen, false = ausblenden, null = Theme-Logik */
    setVisible: function (visible) {
      override = typeof visible === 'boolean' ? visible : null;
      sweep();
      return override;
    },
    isVisible: function (el) {
      var target = el || document.querySelector(SELECTOR);
      if (!target) return false;
      return !target.classList.contains(HIDDEN_CLASS);
    },
    isActive: isActive,
    refresh: init
  };

  /* Kurzform-Hook fuer den A/B-Test (Paket E) */
  window.moonouSaleCountdownVisible = function (visible) {
    return window.MoonouSaleCountdown.setVisible(visible);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Sicherheitsnetz: Ablauf greift auch bei lange offenem Tab. */
  setInterval(sweep, 30000);

  /* Theme-Editor: Blocks werden neu gerendert, danach neu verdrahten. */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
